export const FIELDS = {

  ID: 'id',
  COMPANY_ID: 'companyId',
  PAYMENT_DATE: 'paymentDate',
  PAYMENT_METHOD_ID: 'paymentMethodId',
  PAYMENT_ACCOUNT_ID: 'paymentAccountId',
  REFERENCE_NUMBER: 'referenceNumber',
  AMOUNT: 'amount',
  COMMENTS: 'comments',
  SOURCE_NAME: 'sourceName',
  SOURCE_ID: 'sourceId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  COMPANY_NAME: 'companyName',
  PAYMENT_METHOD_NAME: 'paymentMethodName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};

export const PO_FIELDS = {

  ID: 'id',
  PO_DATE: 'poDate',
  SO_DATE: 'soDate',
  DUE_DATE: 'dueDate',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  BUYER_USER_ID: 'buyerUserId',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  BILLING_TERM_ID: 'billingTermId',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  COMMENTS: 'comments',
  TRACKING_NUMBER: 'trackingNumber',
  STATUS_ID: 'statusId',
  SALES_TYPE_ID: 'salesTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  VENDOR_SHIPPING_CHARGE: 'vendorShippingCharge',
  VENDOR_TAX: 'vendorTax',
  IS_PAID: 'isPaid',
  IS_AUTHORIZED: 'isAuthorized',
  ON_HOLD: 'onHold',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  P_ONUMBER: 'purchaseOrderId',
  COMPANY_NAME: 'companyName',
  CONTACT_FULL_NAME: 'contactFullName',
  BUYER_FULL_NAME: 'buyerFullName',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SHIPPING_DAYS: 'shippingDays',
  SHIPPING_ACCOUNT: 'shippingAccount',
  STATUS_NAME: 'statusName',
  SALES_TYPE_NAME: 'salesTypeName',
  BILLING_TERM_NAME: 'billingTermName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  LINE_COUNT: 'lineCount',
  LINE_TOTAL: 'lineTotal',
  TOTAL: 'total',
  BALANCE: 'balance',
  CONVERTED_COST: 'convertedCost',
  PURCHASING_FOR: 'purchasingFor',
  PURCHASER: 'purchaser',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  AGING: 'aging'
};
